/// <amd-module name="Wit/WorkItemModel/RuleEngine/RuleValueFrom" />
export enum RuleValueFrom {
    Value = 0x01,
    CurrentValue = 0x02,
    OriginalValue = 0x04,
    OtherFieldCurrentValue = 0x08,
    OtherFieldOriginalValue = 0x10,
    CurrentUser = 0x20,
    Clock = 0x40
}
